// A submitted form shows a spinner on its submit buttons.
document.addEventListener('submit', (e) => {
    const buttons = e.target.querySelectorAll('button[type=submit]');

    if (![...buttons].some((button) => button.classList.contains('btn-loading'))) {
        buttons.forEach((button) => {
            button.classList.add('btn-loading');
            button.innerHTML = '<div class="spinner-border" role="status"></div>';
        });
    }
});
